import { gql } from '@apollo/client'

export const CHANGE_TASK_TEMPLATE = gql`
  mutation ChangeTaskTemplate($input: TaskTemplateInput!) {
    changeTaskTemplate(input: $input) {
      task_template_id
      name
      task_info_default
      salary_correction
      timebank_correction
    }
  }
`

export const REMOVE_TASK_TEMPLATE = gql`
  mutation RemoveTaskTemplate($task_template_id: Int!) {
    removeTaskTemplate(task_template_id: $task_template_id) {
      task_template_id
      name
      task_info_default
    }
  }
`

export const CHANGE_TASK_TEMPLATE_BLUEPRINT = gql`
  mutation ChangeTaskTemplateBlueprint($input: TaskTemplateBlueprintInput!) {
    changeTaskTemplateBlueprint(input: $input) {
      template_id
      name
      tasks {
        task_template_blueprint_id
        task_template_id
        role_id
        room_id
        required_num
      }
    }
  }
`
export const REMOVE_TASK_TEMPLATE_BLUEPRINT = gql`
  mutation RemoveTaskTemplateBlueprint($template_id: Int!) {
    removeTaskTemplateBlueprint(template_id: $template_id) {
      template_id
      name
      tasks {
        task_template_blueprint_id
        task_template_id
        role_id
        room_id
        required_num
      }
    }
  }
`
